import {Controller} from "@hotwired/stimulus";

export default class CouponFormController extends Controller {
  static targets = ["formError", 'excludedCities']

  initialize() {
    this.configureExcludedCities(this.citySelect);
  }

  get citySelect() {
    return this.element['coupon[city_id]'];
  }

  onFormChange(event) {
    console.log(event);

    if (event.target.id === 'coupon_city_id') {
      this.configureExcludedCities(this.citySelect);
    }
  }

  configureExcludedCities(select) {
    console.log('City has changed', select.value);

    if (select.value === '') {
      this.excludedCitiesTarget.classList.remove('d-none');
      return;
    }

    this.excludedCitiesTarget.classList.add('d-none');
  }
}
